import { SocketStatus, } from "./ps-workspace.types";
const state = {
    id: null,
    name: null,
    description: null,
    tags: [],
    tagsSaving: false,
    workspace: {
        analyses: [],
        resultSets: [],
        description: null,
        name: null,
    },
    socketStatus: SocketStatus.ACTUAL,
    pendingSocketOperations: [],
    lastSocketErrors: null,
    loading: false,
    saving: false,
    serverError: null,
    serverWarning: null,
    isSubscribed: false,
    scenarioEntityCreating: false,
    resultEntityCreating: false,
    onePanelView: false,
    panelForceExpanded: false,
    renameWorkspaceInProgress: false,
    exportInProgress: false,
    scenarioExportInProgress: false,
    currentScenarioId: null,
    currentScenarioEntity: null,
    currentResultSetId: null,
    currentResultSetElement: null,
    calculationTabularResults: [],
    calculationLineGraphResults: [],
    calculationHeatmapResults: [],
    calculationMetadataResults: [],
    templateAnnotationsGraphResults: null,
    layout: null,
    printCanvasContent: null,
    deleteTarget: null,
    protectedSimpleMetricAttachments: [],
    shouldPersistPanelsState: false,
    duplicatedResultSetId: null,
    metricIdWithHighlightedElements: null,
    metricTypeWithHighlightedElements: null,
    configurationIdWithHighlightedElements: null,
    resultElementsWithLongCalculation: [],
    shouldScrollToResultElement: false,
};
export default state;
